export enum GTMAssetsState {
	HIDE = 'hide',
	PARTIAL = 'partial',
	SHOW = 'show',
}
